// extracted by mini-css-extract-plugin
module.exports = {"root":"OBTCheckBox_root__gWv5B"};